import { Directive, Component, Input, OnInit, ElementRef, Renderer, Injectable } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { Request, RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { DeviceType } from '../devicetype/devicetype';
import { DeviceTypeService } from '../../services/devicetype.service';
import { AssetService } from '../../services/asset.service';
import { ApiResponse } from '../../admin/apiresponse';
import { FirmwareAsset } from '../models/firmwareasset'
import { AdalService } from '../../adal/adal.service';
import { NotificationsService } from 'angular2-notifications';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'devicetype',
    template: require('./admin.firmware.upload.component.html'),
    providers: [DeviceTypeService, AssetService]
})
@Injectable()
export class FirmwareUploadComponent implements OnInit {

    @Input() public url: string;
    @Input() public queueLimit: number;
    @Input() public maxFileSize: number;
    @Input() public autoUpload: boolean;
    @Input() public allowedMimeType: Array<string>;
    @Input() public allowedFileType: Array<string>;
    @Input() public headers: Array<any>;

    public assetForm: FormGroup; 
    public submitted: boolean = false;
    public queryInProgress: boolean;
    public apiResponse: ApiResponse;
    public deviceTypes: DeviceType[];
    URL: any = window.location.protocol + '//' + window.location.host + "/api/asset/";
    //'https://localhost:44384/api/asset/';
    //private fileUploadService: FileUploader;
    private inputs: string[] = ['allowedMimeType',
        'allowedFileType',
        'autoUpload',
        'isHTML5',
        'headers',
        'maxFileSize',
        'queueLimit',
        'removeAfterUpload',
        'url'
    ];

    private uploaderOptions: FileUploaderOptions = { url: window.location.protocol + '//' + window.location.host + '/api/asset/', isHTML5: true };

    private element: ElementRef;
    public uploader: FileUploader = new FileUploader(this.uploaderOptions);
    private renderer: Renderer;
    private multiple: boolean = false;
    public busySub: Subscription;// = Observable.create(() => {});

    formErrors = {
        'devicetype': '',
        'assettype': ''
    };

    validationMessages = {
        'devicetype': {
            'required': 'Name is required.',
            'minlength': 'Name must be at least 4 characters long.',
            'maxlength': 'Name cannot be more than 24 characters long.',
            'forbiddenName': 'Someone named "Bob" cannot be a hero.'
        },
        'assettype': {
            'required': 'Assettype is required.'
        }
    };


    constructor(private fb: FormBuilder,
        private devicetypeService: DeviceTypeService,
        element: ElementRef,
        renderer: Renderer,
        private assetService: AssetService,
        private adal: AdalService,
        private notificationService: NotificationsService) { //, fileUploadService: FileUploader) {
        this.element = element;

        this.renderer = renderer;
    }

    ngOnInit() {
        //for (let input of this.inputs) {
        //    if (this[input]) {
        //        this.uploaderOptions[input] = this[input];
        //    }
        //}
        //this.fileUploadService.setOptions(this.uploaderOptions);
        //for (let input of this.inputs) {
        //    if (this[input]) {
        //        this.uploaderOptions[input] = this[input];
        //    } 
        //}
        //this.fileUploadService.setOptions(this.uploaderOptions);
         
        //this.multiple = (!this.queueLimit || this.queueLimit > 1);

        this.buildForm();
        this.getDeviceTypes();
    }

    buildForm(): void {
        this.assetForm = this.fb.group({
            'devicetype': ['', Validators.compose([Validators.required])],
            'assettype': ['', Validators.compose([Validators.required, Validators.maxLength(256) ])],
            'assetversion': ['', Validators.compose([Validators.required, Validators.maxLength(256)])],
            'compatibleversions': [''],
            'verificationcode': [''],
            'priority': ['']
            //assetfile: [any]
        });

        //this.assetForm.valueChanges
        //    .subscribe(data => this.onValueChanged(data));
        //this.onValueChanged();
        //this.getDeviceTypes();
    }

    //onValueChanged(data?: any) {
    //    if (!this.assetForm) { return; }
    //    const form = this.assetForm;
    //    for (const field in this.formErrors) {
    //        // clear previous error message (if any)
    //        this.formErrors[field] = '';
    //        const control = form.get(field);
    //        if (control && control.dirty && !control.valid) {
    //            const messages = this.validationMessages[field];
    //            for (const key in control.errors) {
    //                this.formErrors[field] += messages[key] + ' ';
    //            }
    //        }
    //    }
    //}

    getDeviceTypes() {
        this.busySub = this.devicetypeService.getDeviceTypes()
            .subscribe(
            success => this.setGetResponse(success),
            error => this.handleError(<any>error)
            );
    }

    public onChange($event: any): void {
        this.uploader.clearQueue();
        this.apiResponse = new ApiResponse();
        this.uploader.addToQueue($event.srcElement.files);        
    }

    uploadAsset(asset: FirmwareAsset) {
        this.submitted = true;
        this.uploader.onBuildItemForm = (fileItem: any, form: any) => { if (asset) form.append('data', JSON.stringify(asset)); }

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            if (response !== "") {
                //var responsePath = 
                var responsePath = JSON.parse(response);
                if (responsePath.IsSuccess) {
                    this.notificationService.success("Upload Successful", responsePath.Message);
                } else {
                    this.notificationService.error("Upload Failed", responsePath.Message);
                }
                //this.apiResponse.statusCode = responsePath.response.statusCode;
                //this.apiResponse.reasonPhrase = responsePath.response.reasonPhrase; 
                //this.apiResponse.isSuccess = responsePath.response.isSuccessStatusCode; 
                //this.apiResponse.data = responsePath.body || [];
            } else {
                this.notificationService.error("Unexpected Response received", "");
                //this.apiResponse.data = [];
                //this.apiResponse.statusCode = status;
            }
        }; 

        this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            //if (response != "") {
            //    var errorResponse = JSON.parse(response);
            //    this.apiResponse.data = errorResponse.body || [];
            //} else {
            //    this.apiResponse.data = [];
            //    this.apiResponse.statusCode = status;
            //}
        };
        asset.assetfile = this.uploader.queue[0].file.name;
        
        let resourceUrl = URL instanceof Request;

        var resource = this.adal.GetResourceForEndpoint(this.URL);
        this.adal.acquireToken(resource)
            .subscribe((token: string) => {
                this.uploader.authToken = 'Bearer ' + token; 
            });
        //this.uploader.options.disableMultipart = true;

        this.uploader.queue[0].upload();
        this.uploader.queue[0]._xhr.upload.addEventListener('progress', function (e) {
           // console.log('progress');  
        }, false);
        this.submitted = false;
    }
    
    setGetResponse(resp: ApiResponse) {
        this.queryInProgress = false;
        this.apiResponse = resp;
        this.deviceTypes = resp.data || [];
    }

    setCreateResponse(resp: ApiResponse) {
        this.apiResponse = resp;
        this.submitted = false;
    }

    private handleError(resp: ApiResponse) {
        console.log(resp);
    }
}




// WEBPACK FOOTER //
// ./app/admin/firmware/admin.firmware.upload.component.ts